export default __webpack_public_path__ + "static/media/dreamland3.08699fc6.jpg";